/**
 * @returns {boolean}
 */
function isHomepage() {
  const navBar = document.querySelector('.main-navbar');
  return navBar?.classList.contains('navbar-transparent');
}

export default isHomepage;
